<template>
  <div class="select" :class="bem('select', { appearance, disabled })">
    <select
      class="select__input"
      v-model="model"
      :multiple="Array.isArray(model)"
      :disabled="disabled"
      :name="name"
    >
      <option v-for="option in options" v-text="option.title" :value="option.value" />
    </select>
  </div>
</template>

<script>
  import { bem } from "src/utils/bem.js";
  import { modelValueConfig } from 'src/utils/vue.js';

  export default {
    name: 'BasicSelect',
    model: modelValueConfig(),
    props: {
      options: {
        type: Array,
        required: true,
      },
      modelValue: [Boolean, String, Number, Object],
      appearance: String,
      disabled: Boolean,
      name: String,
    },
    methods: {
      bem,
    },
    computed: {
      model: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        },
      },
    },
  }
</script>